import { useLocalStorage } from "../storage";
import { STORAGE_KEY_IS_PWA_INSTALLED } from "./pwa.constants";
import { useCallback, useEffect } from "react";
import useMediaQuery, { MEDIA_QUERIES } from "../useMediaQuery";

export const useIsStandAlone = () => {
  const isStandAloneByMediaQuery = useMediaQuery(MEDIA_QUERIES.standAlone);
  const isStandAloneIOS = (global.window?.navigator?.standalone === true);
  const isStandAlone = isStandAloneIOS || isStandAloneByMediaQuery;
  return isStandAlone;
};

export const useIsStandAloneInstalled = () => {
  const isStandAlone = useIsStandAlone();
  const [isPWAInstalled, setIsPWAInstalled] = useLocalStorage(
    STORAGE_KEY_IS_PWA_INSTALLED, false, true
  );

  const handleInstallSuccess = useCallback(() => {
    setIsPWAInstalled(true);
  }, [setIsPWAInstalled]);

  useEffect(() => {
    if (isStandAlone) {
      handleInstallSuccess();
    }
  }, [isStandAlone, handleInstallSuccess]);

  useEffect(() => {
    window.addEventListener("onappinstalled", handleInstallSuccess);

    return () => {
      window.removeEventListener("onappinstalled", handleInstallSuccess);
    };
  }, [handleInstallSuccess]);

  return isPWAInstalled;
};
